import {
  Account,
  AddInvoice,
  Anticipation,
  Dashboard,
  Extract,
  InvoiceBuyers,
  InvoiceDuplicates,
  Payments,
  PayOffice,
  PersonalCard,
  PixArea,
  PixPayment,
  PixSales,
  PixTransfer,
  Receipts,
  Tickets,
  Transfers
} from "../Pages/Private";

import {
  AttachMoney as AttachMoneyIcon,
  CreditCard as CreditCardIcon,
  Dashboard as DashboardIcon,
  FormatListBulleted as FormatListBulletedIcon,
  GroupAdd,
  ReceiptOutlined as PaymentIcon,
  Person as PersonIcon,
  Pix as PixIcon,
  Receipt as ReceiptIcon,
  CancelOutlined as RefoundIcon,
  Repeat as RepeatIcon,
  RequestQuote,
  ViewWeek as ViewWeekIcon
} from "@mui/icons-material";
import { Support } from "../Pages/Private";
import { SupportAgent as SupportIcon } from "@mui/icons-material";
import { PixDetails } from "../Components/Molecules/PixDetails";
import { PermissionId } from "../Contexts/AuthContext";
import { Operators } from "../Pages/Private/Operators";
import { Organizers } from "../Pages/Private/Organizers";
import DetailsOrganizer from "../Pages/Private/Organizers/Details";
import { PaymentDetails } from "../Pages/Private/PayOffice/tabs/payments/details";
import Payroll from "../Pages/Private/Payroll";
import PayrollDetail from "../Pages/Private/Payroll/details";
import { Refunds } from "../Pages/Private/Refunds";
import { AddTicket } from "../Pages/Private/Tickets/AddTicket";

export interface IMenuRoute {
  path: string;
  label?: string;
  icon?: any;
  exact?: boolean
  isHidden?: boolean;
  permission?: PermissionId
  component: () => JSX.Element
}

export const routes: IMenuRoute[] = [
  {
    path: "/",
    label: "Início",
    permission: "statementsview",
    component: () => <Dashboard />,
    icon: DashboardIcon,
  },
  {
    path: "/extrato",
    label: "Extrato",
    permission: "statementsview",
    component: () => <Extract />,
    icon: FormatListBulletedIcon,
  },
  {
    path: "/pix",
    label: "Área Pix",
    permission: "pixview",
    component: () => <PixArea />,
    icon: PixIcon,
  },
  {
    path: "/transferencia",
    label: "Transferências",
    permission: 'p2pview',
    component: () => <Transfers />,
    icon: RepeatIcon,
  },
  {
    path: "/pagamento",
    label: "Pagamentos",
    permission: "payboleto",
    component: () => <Payments />,
    icon: PaymentIcon,
  },
  {
    path: "/boletos",
    permission: "boletocreateview",
    label: "Boletos",
    component: () => <Tickets />,
    icon: ViewWeekIcon,
  },
  {
    path: "/boletos/add",
    permission: "boletocreateview",
    label: "Criar Boleto",
    component: () => <AddTicket />,
  },
  {
    path: "/comprovantes",
    label: "Comprovantes",
    permission: "statementsview",
    component: () => <Receipts />,
    icon: ReceiptIcon,
  },
  {
    path: "/estornos",
    label: "Estornos",
    permission: "statementsview",
    component: () => <Refunds />,
    icon: RefoundIcon,
  },
  {
    path: "/payroll",
    label: "Folha de pagamento",
    permission: "payrollview",
    component: () => <Payroll />,
    icon: ReceiptIcon,
  },
  {
    path: "/pontos-de-venda",
    label: "Pontos de Venda",
    permission: "subaccountview",
    component: () => <Organizers />,
    icon: AttachMoneyIcon,
  },
  {
    path: "/operadores",
    label: "Operadores",
    permission: "admin",
    component: () => <Operators />,
    icon: GroupAdd,
  },
  {
    path: "/meus-cartoes",
    label: "Meu cartão",
    component: () => <PersonalCard />,
    isHidden: true,
    icon: CreditCardIcon,
  },
  {
    path: "/pontos-de-venda/:subAccountId",
    label: "Detalhes do PV",
    component: () => <DetailsOrganizer />,
  },
  {
    path: "/pay-office",
    label: "Pagadoria",
    exact: false,
    isHidden: true,
    component: () => <PayOffice />,
    permission: "pagadoriaview",
    icon: ReceiptIcon,
  },
  {
    path: "/pay-office/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})",
    exact: true,
    component: () => <PaymentDetails />,
  },
  {
    path: "/payroll/:id",
    label: "Detalhes do arquivo de folha de pagamento",
    component: () => <PayrollDetail />,
  },
  // legacy operator create/edit routes removed; handled via modal in Operators page

  {
    path: "/pix/transferencia",
    label: "Transferência Pix",
    component: () => <PixTransfer />,
  },
  {
    path: "/pix/copia-cola",
    label: "Pix copia e cola",
    component: () => <PixPayment />,
  },
  {
    path: "/pix/vendas",
    label: "Vender",
    component: () => <PixSales />,
  },
  {
    path: "/pix/detalhes",
    label: "Pix Detalhes",
    component: () => <PixDetails />,
  },
  {
    path: "/anticipation",
    label: "Antecipação",
    isHidden: false,
    component: () => <Anticipation />,
    permission: 'antecipationview',
    icon: RequestQuote,
  },
  {
    path: "/anticipation/addInvoice",
    label: "Adicionar Notas Fiscais",
    component: () => <AddInvoice />,
  },
  {
    path: "/anticipation/buyers",
    label: "Compradores",
    component: () => <InvoiceBuyers />,
  },
  {
    path: "/anticipation/duplicates",
    label: "Duplicatas",
    component: () => <InvoiceDuplicates />,
  },
  {
    path: "/perfil",
    label: "Meu Perfil",
    component: () => <Account />,
    icon: PersonIcon,
  },

  {
    path: "/suporte",
    label: "Suporte e Ajuda",
    component: () => <Support />,
    icon: SupportIcon,
  },

  // DEFAULT ROUTE
  {
    path: "*",
    component: () => <Dashboard />,
    isHidden: true,
  }
];
